import { apiRequest } from './api'
import type {
  Business,
  ListBusinessesParams,
  ListBusinessesResponse,
  CreateBusinessData,
  UpdateBusinessData,
} from '@/types'

/**
 * List businesses with pagination.
 */
export async function listBusinesses(
  params: ListBusinessesParams = {}
): Promise<ListBusinessesResponse> {
  const queryParams = new URLSearchParams()

  if (params.limit !== undefined) {
    queryParams.set('limit', params.limit.toString())
  }
  if (params.offset !== undefined) {
    queryParams.set('offset', params.offset.toString())
  }

  const queryString = queryParams.toString()
  const url = queryString ? `/businesses/list?${queryString}` : '/businesses/list'

  return apiRequest<ListBusinessesResponse>(url)
}

/**
 * Get single business by ID.
 */
export async function getBusiness(id: string): Promise<Business> {
  return apiRequest<Business>(`/businesses/get/${encodeURIComponent(id)}`)
}

/**
 * Create a new business.
 */
export async function createBusiness(data: CreateBusinessData): Promise<Business> {
  return apiRequest<Business>('/businesses/create', {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

/**
 * Update an existing business.
 */
export async function updateBusiness(
  id: string,
  data: UpdateBusinessData
): Promise<Business> {
  return apiRequest<Business>(`/businesses/update/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  })
}

/**
 * Delete a business (soft delete).
 */
export async function deleteBusiness(id: string): Promise<void> {
  await apiRequest<{ message: string }>(
    `/businesses/delete/${encodeURIComponent(id)}`,
    {
      method: 'DELETE',
    }
  )
}
